import { parseISO } from "date-fns";

export const checkIfApplicationJobs = (scheduleRequest) =>
  scheduleRequest.filter((job) => job.is_application === 1).length !== 0;

/**
 * Javascript will treat strings as Dates but `date-fns` will not.
 */
export const convergeDate = (arg: Date | string): Date =>
  typeof arg === "string" ? parseISO(arg) : arg;

export class TimeoutSynchronizer {
  private timeoutInProgress: NodeJS.Timeout | 0 = 0;

  private actions: Array<() => void> = [];

  constructor(private timeoutInterval: number) {}

  setSynchronizedTimeout(action: () => void) {
    this.actions.push(action);
    if (!this.timeoutInProgress) {
      this.timeoutInProgress = setTimeout(() => {
        this.timeoutInProgress = 0;
        this.actions.forEach(act => act());
        this.actions = [];
      }, this.timeoutInterval);
    }
  }
}
